import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';
import { BaseResponse, GenericList } from '../commons/generic.responses';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private _http: HttpClient) { }

  SearchCatalog(searchParam: string, endpoint: string): Observable<GenericList[]> {
    if (searchParam?.length < 2) return of([]);

    return this._http.get<BaseResponse<GenericList[]>>(`${endpoint}?SearchParam=${searchParam}`).pipe(
      map(res => {
        return res?.body?.result;
      })
    );
  }

}
